import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueAxios from 'vue-axios';
import axios from 'axios';
import store from '@/vuex/store';
import { initInterceptor } from './request.interceptor';
import { BootstrapVue } from 'bootstrap-vue';
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue';
import PortalVue from 'portal-vue';
import moment from 'moment';
import Loader from '@/components/Loader.vue';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(PortalVue);

Vue.component('Loader', Loader);

moment.locale('nl');

export const vueInstance: any = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

initInterceptor();

